export default __webpack_public_path__ + "static/media/CompoundWords_20.76f81da9.png";